import { toast } from "react-toastify";
import { t } from "i18next";
import { historyRepository } from "../../../providers/repositories/historyRepository";
import Logger from "../../../utils/Logger";
import type {
  DeletedRecord,
  HistoryCollection,
} from "../entities/HistoryVersion";

/// Récupère les éléments liés supprimés d'un enregistrement (parts d'un topic, questions d'une
/// part), chacun accompagné de sa propre descendance supprimée.
export const getDeletedChildrenUseCase = {
  async exec(
    collection: HistoryCollection,
    recordId: string,
  ): Promise<DeletedRecord[]> {
    try {
      return await historyRepository.getDeletedChildren(collection, recordId);
    } catch (error) {
      toast.error(t("history.loadError"));
      Logger.error("getDeletedChildrenUseCase", error);
    }
    return [];
  },
};
